import * as types from "../actions/action-types";

const initialState = {};
export default function teamReducer(state = initialState, action) {
  switch (action.type) {
    case types.GAME_DATA:
      return Object.assign({}, state, {
        gameData: action.gameData,
      });
    case types.GAME_EVENTS:
      return Object.assign({}, state, {
        gameEvents: action.gameEvents,
      });

    case types.BASKET_GAMES_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.BASKET_GAMES_SET:
      return {
        ...state,
        loading: false,
        items: action.payload,
      };

    case types.BASKET_GAMES_ADD:
      return {
        ...state,
        loading: false,
        items: [...state.items, action.payload],
      };

    case types.BASKET_GAMES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
